import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'gwc-frontend-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderComponent {

	@Input('env') env: any;

	public mainMenuItems: {display: string, url: string | string[], selected: boolean}[] | null = null

	private _accesscode: string | null = null;

	constructor(
		private _router: Router,
		private _activatedRoute: ActivatedRoute
	) {

		this._initMainMenu();

	 }

	ngOnInit() {

	}


	goToMainSite() {
		window.location.href = 'https://www.gwcregaliahire.nz';
	}


	itemClicked(url: string | string[]) {
		if(typeof url == 'string') {
			window.location.href = url;
		}

		this._router.navigate(url as string[])
	}



	private _initMainMenu() {
		
		this.mainMenuItems = [
			{
				display: 'Hire Regalia',
				url: this.env?.production ? 'https://orders.gwcregaliahire.nz' : [ ( this._accesscode ? this._accesscode + '/' : '' ) + 'reset-order-form'],
				selected: true
			},
			{
				display: 'Who we are',
				url: 'https://gwcregaliahire.nz/#who-we-are',
				selected: false
			},
			{
				display: 'Interested in volunteering?',
				url: 'https://gwcregaliahire.nz/#volunteer',
				selected: false
			},
			{
				display: 'Contact us',
				url: 'https://gwcregaliahire.nz/#contact',
				selected: false
			}
		]
	}

}
